import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  return (
    <header 
      className={`header d-flex align-items-center position-fixed w-100 ${isScrolled ? 'scrolled' : ''}`}
    >
      <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center">
          <img src="/assets/img/logo.png" alt="AgriCulture" width="200" height="auto" />
        </a>

        <nav className={`navmenu ${isMobileNavOpen ? 'mobile-nav-active' : ''}`}>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/service" clssName="active">Our Services</a></li>
            
            <li><a href="/blog">Blog</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </nav>

        <button 
          className="mobile-nav-toggle d-xl-none bi bi-list"
          onClick={toggleMobileNav}
          aria-label="Toggle Navigation"
        >
        </button>
      </div>

      <style jsx>{`
        .header {
          transition: all 0.5s;
          z-index: 997;
          padding: 30px 0;
          background: transparent;
          height: auto; 
        }

        .header.scrolled {
          padding: 15px 0;
          background: #fff;
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
          height: 100px; /* Reduced height when scrolled */
        }

        .logo img {
          max-width: 202px; /* Golden ratio width */
          width: 100%;
          height: auto; /* Base height */
          margin-right: 6px;
          transition: transform 0.2s ease;
        }
        
        .logo img:hover {
          transform: scale(1.5);
        }

        /* iPhone-specific styles */
        @media only screen and (max-width: 767px) and (-webkit-min-device-pixel-ratio: 2) {
          .logo img {
            max-width: 130px; /* Optimized for iPhone */
            height: auto;
          }
        }

        /* General mobile styles (including Android) */
        @media only screen and (max-width: 767px) {
          .logo img {
            max-width: 130px; /* Consistent with iPhone */
            height: auto;
          }
        }

        .navmenu {
          padding: 0;
          margin: 0;
        }

        .navmenu ul {
          margin: 0;
          padding: 0;
          display: flex;
          list-style: none;
          align-items: center;
        }

        .navmenu li {
          position: relative;
          padding: 10px 20px;
        }

        .navmenu a {
          display: flex;
          align-items: center;
          color: #000;
          font-weight: 500;
          font-size: 15px;
          text-decoration: none;
          transition: 0.3s;
        }

        .navmenu a:hover,
        .navmenu .active {
          color: #4CAF50;
        }

        .mobile-nav-toggle {
          display: none;
          color: #000;
          font-size: 28px;
          cursor: pointer;
          line-height: 0;
          transition: 0.5s;
          border: 0;
          background: none;
          padding: 0;
        }

        @media (max-width: 1200px) {
          .mobile-nav-toggle {
            display: block;
          }

          .navmenu {
            position: fixed;
            top: 0;
            right: -100%;
            width: 261.8px; /* Golden ratio based width */
            bottom: 0;
            transition: 0.3s;
            z-index: 9997;
            background: #fff;
            box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
            padding: 80px 0;
          }

          .navmenu.mobile-nav-active {
            right: 0;
          }

          .navmenu ul {
            display: block;
            padding: 0;
          }

          .navmenu a {
            padding: 10px 20px;
            font-size: 15px;
            color: #000;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;